export default __webpack_public_path__ + "pikachu.c98128de.png";